import Intercom from "@intercom/messenger-js-sdk";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorModal from "./components/Alerts/ErrorModal";
import SuccessModal from "./components/Alerts/SuccessModal";
import NotificationPrompt from "./components/NotificationPrompt/NotificationPrompt";
import Router from "./routes/Router";
import { clearPersistedData } from "./store/configureStore";
import { setDefaultDateForBalanceChart } from "./store/reducers/accountSlice";
import { deAuthenticate, setIsProfilePopupVisible } from "./store/reducers/authSlice";
import { PURGE_Brand } from "./store/reducers/brandSlice";
import { Modal } from "antd";
import { generateRandomId, getDeviceType } from "./utils/helpers/browserID";
import { startTokenRefresh, stopTokenRefresh } from "./utils/tokenRefreshService";

function App() {
  const data = useSelector((state) => state.account.accountList);
  const { userId, isAuthenticated, refreshToken, rememberMe } = useSelector((state) => state?.auth);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  let ee_device_id = localStorage.getItem("ee-device-id");

  if (!ee_device_id) {
    ee_device_id = generateRandomId();
    localStorage.setItem("ee-device-id", ee_device_id);
  }

  axios.defaults.headers.common["X-EE-Device-Id"] = ee_device_id;
  axios.defaults.headers.common["X-Device-Type"] = getDeviceType();

  let ee_session_token = localStorage.getItem("ee-session-token");
  if (ee_session_token) {
    axios.defaults.headers.common["X-SESSION-TOKEN"] = ee_session_token;
  }

  // Start token refresh timer when user is authenticated with Remember Me
  useEffect(() => {
    if (isAuthenticated && rememberMe && refreshToken) {
      startTokenRefresh(dispatch, refreshToken, rememberMe);
    } else {
      stopTokenRefresh();
    }

    // Cleanup on unmount
    return () => {
      stopTokenRefresh();
    };
  }, [isAuthenticated, rememberMe, refreshToken, dispatch]);

  useEffect(() => {
    const createdAt = Math.floor(Date.now() / 1000);
    let authUser = {
      app_id: "oa4kzzll",
      user_id: userId,
      name: `${user?.first_name} ${user?.last_name}`,
      email: user?.email,
      created_at: createdAt,
    };

    let unAuthUser = {
      app_id: "oa4kzzll",
    };

    if (isAuthenticated) {
      Intercom(authUser);
    } else {
      Intercom(unAuthUser);
      Intercom("shutdown");
    }
  }, [isAuthenticated, userId, user]);

  // const idToken = useSelector((state) => state.auth.idToken);

  // const firstAccount = useSelector((state) => state.account.accountList.data[0]);
  // const loginId = activeAccount || firstAccount;
  // useEffect(() => {
  //   dispatch(getAccountMetrics({idToken, loginId}));
  //
  // }, [loginId]);
  useEffect(() => {
    const isProduction = window.location.hostname === "app.equityedge.io";
    if (!window.location.pathname.includes("program-objectives")) {
      dispatch(setDefaultDateForBalanceChart({ start_date: "", end_date: "" }));
    }

    if (isProduction) {
      console.log = () => { };
    }
  }, [window.location.pathname]);

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  useEffect(() => {
    document.body.classList.remove("equity_edge", "futures_edge", "crypto_edge");
    document.body.classList.add(selectedBrand.brand); // Use `.brand`
  }, [selectedBrand.brand]); // Depend on `selectedBrand.brand`

  return data ? (
    <>
      <ToastContainer />
      <NotificationPrompt />
      <Router />
      <SuccessModal />
      <ErrorModal />
      <ModalDetails dispatch={dispatch} />
    </>
  ) : null;
}

export default App;
const ModalDetails = ({ dispatch }) => {
  const { isProfileComplete } = useSelector((state) => state.auth);

  // Determine the message based on missing fields
  let message = "";
  const missingContact = isProfileComplete?.contact;
  const missingCountry = isProfileComplete?.country;

  if (missingContact && missingCountry) {
    message = "Kindly add your contact and country info to continue using the platform.";
  } else if (missingContact) {
    message = "Kindly add your contact info to continue using the platform.";
  } else if (missingCountry) {
    message = "Kindly add your country info to continue using the platform.";
  }

  return (
    <Modal
      open={isProfileComplete?.isVisible}
      footer={null}
      centered
      closable={false}
      bodyStyle={{ backgroundColor: "#102717" }}
      className="profile-modal"
    >
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h2 style={{ color: "#fff" }}>Please complete your profile details</h2>
        {/* Only show the message if some info is missing */}
        {message && <p style={{ color: "#fff", marginBottom: "20px" }}>{message}</p>}
        <a
          href="/myprofile/general-information"
          onClick={() => dispatch(setIsProfilePopupVisible({ isVisible: false }))}
          style={{ color: "#fff", textDecoration: "underline" }}
        >
          Update Profile
        </a>
      </div>
    </Modal>
  );
};
